import FiltersSetterController, {
  TFilterSaveInput,
} from './FiltersSettersController';
import { observer } from 'mobx-react-lite';
import { TApiaFilter } from '../../../../../types';
import { Input, validationsStore } from '@apia/validations';
import { reaction } from 'mobx';

const InputFilterSetter = observer(
  ({
    controller,
    filter,
    i,
    handleChangingFilter,
  }: {
    controller: FiltersSetterController;
    filter: TFilterSaveInput & {
      filter: TApiaFilter;
      readonly: boolean;
      required: boolean;
    };
    i: number;
    handleChangingFilter: (value: string, i: number) => void;
  }) => {
    reaction(
      () => controller.filters[i] as TFilterSaveInput,
      (changingFilter: TFilterSaveInput) => {
        const input = validationsStore.getFieldStore(
          'FiltersSetter',
          filter.id,
        );
        input.value = changingFilter.value;
      },
    );
    return (
      <Input
        type={filter.type}
        name={filter.id}
        validationRules={{ required: filter.required }}
        readOnly={filter.readonly}
        value={(controller.filters[i] as TFilterSaveInput).value}
        onChange={(ev) => {
          (controller.filters[i] as TFilterSaveInput).value = ev.target.value;

          handleChangingFilter(ev.target.value, i);
        }}
      />
    );
  },
);

export default InputFilterSetter;
